import * as actions from 'client/actions/entityActions'
import { useCallback } from 'react'

export default function useUpdateEntityMobileOption(dispatch, entity) {
  return useCallback(
    option => value =>
      dispatch(
        actions.update({
          ...entity,
          mobileOptions: {
            ...entity.mobileOptions,
            [option]: value,
          },
        }),
      ),
    [entity],
  )
}
